import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import validate from '../../../utils/validate';
import { createGenieProjectYopValidation } from '../validation';
import GenieCreationForm from './GenieCreationForm';
import { createGenieProject } from '../../../redux/projects/projectsActions';
import { getGenieBrandOptions } from '../../../redux/genie/genieActions';

function GenieCreation() {
  const dispatch = useDispatch();

  const createGenieProjectInitialValues = {
    projectName: '',
    brand: '',
    assignUser: '',
    activeUsers: [],

    activeAllAssistants: [],
  };

  const handleCreateProject = (values) => {
    dispatch(createGenieProject(values));
  };

  useEffect(() => {
    dispatch(getGenieBrandOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      initialValues={createGenieProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createGenieProjectYopValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <GenieCreationForm handleSubmit={handleSubmit} />}
    />
  );
}

export default GenieCreation;
